module.exports = __webpack_public_path__ + "static/media/stats-mobile2.bc72227b.png";